import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

/* 짧은 링크 /go/<code> — 보통은 nginx 가 백엔드로 넘겨 302 로 바로 이동한다.
   nginx 설정이 아직 반영되지 않은 서버에서도 동작하도록 SPA 에서 한 번 더 처리한다. */
export default function ShortLink() {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    let alive = true;
    fetch(`/api/landing/go/${encodeURIComponent(code)}`)
      .then((r) => (r.ok ? r.json() : null))
      .catch(() => null)
      .then((data) => {
        if (alive) navigate((data && data.to) || "/for", { replace: true });
      });
    return () => { alive = false; };
  }, [code, navigate]);

  return <section className="lp-hero"><div className="lp-hero__inner"><p className="lp-hero__lead">이동 중…</p></div></section>;
}
